import { getWindowConfig, } from '~/utils/env';
import { MoveWithin, } from './move-within';

MoveWithin('#app', (s) => getWindowConfig(s));
